import { render } from "./TemaBlaaGroenFaktor.vue?vue&type=template&id=54ce782b"
import script from "./TemaBlaaGroenFaktor.vue?vue&type=script&lang=js"
export * from "./TemaBlaaGroenFaktor.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__